<div class="loader-container h-150px">
  <div class="loader-bar"></div>
  <p class="loader-text text-gray-800">Connecting….</p>
  <p class="countdown-text">{{ countdown }}s</p>
</div>
<!-- <div class="loader-containers">
  <img
    src="https://developmentcontent.blob.core.windows.net/resources/governance/1.1/start_connecting.gif"
    alt="Loading"
    class="loader-img"
  />
</div> -->
